import { axios } from 'config/axios'
import { GetOneResponse } from 'interfaces/api.interfaces'
import { WidgetCategoryTypes } from 'modules/editMode/interfaces'

import { editModeEndpoints } from './endpoints'
import { WidgetsList, WidgetsListForm } from './interfaces'

const getEditModeSettings = async (category?: WidgetCategoryTypes): GetOneResponse<WidgetsList> => {
  const { data } = await axios.request<WidgetsList>({
    method: 'GET',
    url: editModeEndpoints.getEditModeSettings(),
    params: {
      categoryWidget: category,
    },
  })
  return data
}

const updateEditModeSettings = async (form: WidgetsListForm): Promise<void> => {
  await axios.request({
    method: 'PATCH',
    url: editModeEndpoints.updateEditModeSettings(),
    data: form,
  })
}

export const editModeApi = {
  getEditModeSettings,
  updateEditModeSettings,
}
